import React from 'react';

import {DefaultTheme} from 'styled-components';

import * as S from './style';

export type TProps = {
  className?: string;
  size?: number;
  thickness?: number;
  percentage: number;
  color?: keyof DefaultTheme['palette'];
  children?: React.ReactNode;
};

export const CircularProgressBar: React.FC<TProps> = ({
  className,
  size = 100,
  thickness = 2,
  percentage = 0,
  color,
  children,
}) => {
  const radius = (size - thickness) / 2;
  const viewBox = `0 0 ${size} ${size}`;
  const dashArray = radius * Math.PI * 2;
  const dashOffset = (dashArray * percentage) / 100 - dashArray;

  return (
    <S.CircularProgressBar size={size} className={className}>
      <svg width={size} height={size} viewBox={viewBox}>
        <S.Progress
          color={color}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={`${thickness}px`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset,
          }}
        />
      </svg>
      <S.Children>{children}</S.Children>
    </S.CircularProgressBar>
  );
};

export default CircularProgressBar;
